import { connect } from 'react-redux';

import OutreachConfigurationView from './OutreachConfigurationView.jsx';
import { updateConfiguration} from 'src/legacy/redux/actions/integrations/outreach.jsx';

const mapStateToProps = (state, ownProps) => {
  return {
    errors: state.legacyRootReducer.settings.integrations.outreach.changes.error,
    updating: state.legacyRootReducer.settings.integrations.outreach.changes.saving,
    loading: state.legacyRootReducer.settings.integrations.outreach.changes.loading,
    user: state.users.me,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateConfiguration: (configuration) => {
      return dispatch(updateConfiguration(configuration));
    }
  }
}

const OutreachConfigurationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(OutreachConfigurationView);

export default OutreachConfigurationPage;
